import { Auth } from 'aws-amplify'
import {
  API_URL,
  PUBLIC_API_URL,
  MODE,
} from 'src/constants'

const getHeaders = async () => {
  const session = (
    (await Auth.currentSession().catch(
      () => undefined,
    )) as any
  )?.getIdToken()
  const token = session?.getJwtToken()
  const sub = session?.payload?.sub

  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    ...(MODE === 'local' ? { 'X-User-Id': sub } : {}),
  }
}

const getIsLoggedIn = async () => {
  try {
    await Auth.currentSession()
    return true
  } catch {
    return false
  }
}

const getApiUrl = async () => {
  const isLoggedIn = await getIsLoggedIn()
  return isLoggedIn ? API_URL : PUBLIC_API_URL
}

const parseSearchParams = (params: Record<string, any>) =>
  new URLSearchParams(
    Object.entries(params || {}).reduce(
      (p, [key, value]) => {
        if (value == null) return p

        p[key] = `${value}`
        return p
      },
      {} as Record<string, string>,
    ),
  )

const query = async (url: string, rest: any = {}) => {
  const apiUrl = await getApiUrl()
  const { params, body, headers, ...options } = rest

  const defaultHeaders = await getHeaders()

  return await fetch(
    `${apiUrl}/${url}?${parseSearchParams(
      params,
    ).toString()}`,
    {
      headers: {
        ...defaultHeaders,
        ...(headers || {}),
      },
      ...(body && { body: JSON.stringify(body) }),
      ...options,
    },
  )
}

const get = async (url: string, rest: any = {}) =>
  await (await query(url, rest)).json()

const post = async (
  url: string,
  body: any,
  rest: any = {},
) =>
  await (
    await query(url, { ...rest, body, method: 'POST' })
  ).json()

const put = async (
  url: string,
  body: any,
  rest: any = {},
) =>
  await (
    await query(url, { ...rest, body, method: 'PUT' })
  ).json()

export { get, post, put, query }
